(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .controller('NationalBrokerageDeleteController',NationalBrokerageDeleteController);

    NationalBrokerageDeleteController.$inject = ['$uibModalInstance', 'entity', 'NationalBrokerage'];

    function NationalBrokerageDeleteController($uibModalInstance, entity, NationalBrokerage) {
        var vm = this;

        vm.nationalBrokerage = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            NationalBrokerage.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
